import styled from 'styled-components';

export const Component = styled.div`
  position: absolute;
  top: 0;
  left: var(--value, 0);
  bottom: 0;
  transform: translateX(-50%);

  &::before {
    content: '';

    position: absolute;
    top: 0;
    left: -0.5px;
    bottom: 0;

    border-left: 1px dashed #0060eb;
  }
`;
